import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { Nationality } from "Globals/Models/Nationality";

export class NationalityStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private nationality: Nationality[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.nationality = initialState.nationalities;
    }

    @MobX.action
    public getNationalityName(nationalityId: string | null): string {
        if (nationalityId == "0" || nationalityId == null || nationalityId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => nationalityId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): Nationality[] {
        return this.nationality.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getNationalityOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
